import { render, staticRenderFns } from "./SupportSUP.vue?vue&type=template&id=2c1c072a&scoped=true"
import script from "./SupportSUP.vue?vue&type=script&lang=js"
export * from "./SupportSUP.vue?vue&type=script&lang=js"
import style0 from "./SupportSUP.vue?vue&type=style&index=0&id=2c1c072a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c072a",
  null
  
)

export default component.exports